var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-1"},[_c('b-modal',{ref:"tip-modal",attrs:{"size":"sm","id":"modal-center","centered":"","hide-footer":"","hide-title":"","title":"提示"}},[_c('div',{staticClass:"d-flex justify-content-center p-2"},[_c('span',{staticClass:"text-primary"},[_vm._v("支付满10元可享随机减免优惠。")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }